<app-modal #preProvaQuizModal size="lg">
  <div class="modal-content top-0">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "COL.LESSONS.DETAILS.QUIZ." + quizName + ".TITLE" | translate }}</h5>
      <button type="button"
              class="btn btn-close btn-close-white"
              (click)="preProvaQuizModal.hide()"
              aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <div *ngFor="let q of questions; let i = index" class="mb-3">
        <div class="mb-1">
          <span class="fw-bold small">{{ q.question }}</span>
        </div>
        <div *ngFor="let ans of q.answers; let y = index" class="form-check">
          <input
            class="form-check-input"
            type="radio"
            [id]="quizName + 'q' + i + 'a' + y"
            [name]="quizName + 'q' + i"
            [value]="ans.key"
            [(ngModel)]="selectedAnswers[i+1]"
          />
          <label
            class="form-check-label"
            [ngClass]="{ 'fw-bold': selectedAnswers[i+1] === ans.key }"
            [for]="quizName + 'q' + i + 'a' + y"
          >
            {{ ans.text }}
          </label>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div
        *ngIf="!allAnswered()"
        id="notAllAnswered"
        class="cursor-pointer d-inline-block"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title="{{'COL.LESSONS.DETAILS.QUIZ.TOOLTIP' | translate }}"
      >
        <button
          class="btn btn-primary rounded-pill px-3"
          disabled
        >
          {{ "BUTTON.CHECK_ANSWERS" | translate }}
        </button>
      </div>
      <button
        *ngIf="allAnswered()"
        class="btn btn-primary rounded-pill px-3"
        (click)="checkAnswers()"
      >
        {{ "BUTTON.CHECK_ANSWERS" | translate }}
      </button>
    </div>
  </div>
</app-modal>
<app-modal #resultModal>
  <div class="modal-content top-0">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "COL.LESSONS.DETAILS.QUIZ." + quizName + ".RESULT.TITLE" | translate }}</h5>
      <button type="button"
              class="btn btn-close btn-close-white"
              (click)="resultModal.hide()"
              aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <p>{{ "COL.LESSONS.DETAILS.QUIZ.CORRECT_ANSWERS" | translate }}: {{ score }}/{{ questions.length }}</p>
      <p>{{resultKey | translate}}</p>
    </div>
    <div class="modal-footer">
      <button  class="btn btn-primary rounded-pill px-3" (click)="resultModal.hide()">
        {{ "BUTTON.OK" | translate }}
      </button>
    </div>
  </div>
</app-modal>
